import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCreditPoolById, updateCreditPoolNameById, updateCreditPoolMembersById, removeDealById } from './creditPool.thunks';
import { ICreditPool, ICreditPoolState } from './interfaces';

const initialState: ICreditPoolState = {
  loading: false,
  selectedCreditPoolId: null,
  creditPool: null,
  isUpdatingName: false,
  isUpdatingMembers: false,
  isDeletingDeal: false
};

const creditPoolSlices = createSlice({
  name: 'creditPool',
  initialState,
  reducers: {
    setSelectedCreditPoolId: (state, action: PayloadAction<string | null>) => {
      state.selectedCreditPoolId = action.payload;
    }
  },
  extraReducers: {
    [fetchCreditPoolById?.pending.type]: (state) => {
      state.loading = true;
      state.creditPool = null;
    },
    [fetchCreditPoolById?.fulfilled.type]: (state, action: PayloadAction<ICreditPool>) => {
      state.loading = false;
      state.creditPool = action.payload;
    },
    [fetchCreditPoolById?.rejected.type]: (state) => {
      state.loading = false;
      state.creditPool = null;
    },
    [updateCreditPoolNameById?.pending.type]: (state) => {
      state.isUpdatingName = true;
    },
    [updateCreditPoolNameById?.fulfilled.type]: (state, action: PayloadAction<Pick<ICreditPool, 'name'>>) => {
      state.isUpdatingName = false;
      if (state.creditPool) {
        state.creditPool.name = action.payload.name;
      }
    },
    [updateCreditPoolNameById?.rejected.type]: (state) => {
      state.isUpdatingName = false;
    },
    [updateCreditPoolMembersById?.pending.type]: (state) => {
      state.isUpdatingMembers = true;
    },
    [updateCreditPoolMembersById?.fulfilled.type]: (state, action: PayloadAction<{members: string[]}>) => {
      state.isUpdatingMembers = false;
      if (state.creditPool && action.payload.members) {
        state.creditPool.members = action.payload.members;
      }
    },
    [updateCreditPoolMembersById?.rejected.type]: (state) => {
      state.isUpdatingMembers = false;
    },
    [removeDealById?.pending.type]: (state) => {
      state.isDeletingDeal = true;
    },
    [removeDealById?.fulfilled.type]: (state) => {
      state.isDeletingDeal = false;
    },
    [removeDealById?.rejected.type]: (state) => {
      state.isDeletingDeal = false;
    }
  }
});

export const actions = {
  ...creditPoolSlices.actions
};

export const creditPoolReducer = creditPoolSlices.reducer;
